import { createSlice } from "@reduxjs/toolkit"

const scrollSlice = createSlice({
    name: 'scroll',
    initialState: {
        isActive: true
    },
    reducers: {
        setScroll: (state, action) => {
            state.isActive = action.payload
        }
    }
})

export const { setScroll } = scrollSlice.actions;
export default scrollSlice.reducer;